import { Box, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { colorsByStatus } from './constants';
import { PartnerProfileStatuses } from '@trnsact/trnsact-shared-types';

export const PartnerProfileStatusBubble = ({ status }: { status?: PartnerProfileStatuses }) => {
  const classes = useStyles(status ? colorsByStatus[status] : colorsByStatus[PartnerProfileStatuses.Staged]);

  return (
    <Box className={classes.container}>
      <Typography align="center" component="span" variant="body2">
        {status}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles<Theme, { color: string; bgColor: string }>({
  container: {
    display: 'inline-flex',
    borderRadius: '4px',
    padding: '4px 8px',
    color: ({ color }) => color,
    backgroundColor: ({ bgColor }) => bgColor,
  },
});
